var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLifeBuoy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z",
    fill: "#60666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z",
    fill: "#60666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22289 4.22282C4.61341 3.8323 5.24658 3.8323 5.6371 4.22282L9.8771 8.46283C10.2676 8.85335 10.2676 9.48651 9.8771 9.87704C9.48658 10.2676 8.85341 10.2676 8.46289 9.87704L4.22289 5.63704C3.83236 5.24651 3.83236 4.61335 4.22289 4.22282Z",
    fill: "#60666E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1229 14.123C14.5134 13.7324 15.1466 13.7324 15.5371 14.123L19.7771 18.363C20.1676 18.7535 20.1676 19.3867 19.7771 19.7772C19.3866 20.1677 18.7534 20.1677 18.3629 19.7772L14.1229 15.5372C13.7324 15.1467 13.7324 14.5135 14.1229 14.123Z",
    fill: "#60666E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7771 4.22282C20.1676 4.61335 20.1676 5.24651 19.7771 5.63704L15.5371 9.87704C15.1466 10.2676 14.5134 10.2676 14.1229 9.87704C13.7324 9.48651 13.7324 8.85335 14.1229 8.46283L18.3629 4.22282C18.7534 3.8323 19.3866 3.8323 19.7771 4.22282Z",
    fill: "#60666E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0671 4.93279C19.4576 5.32331 19.4576 5.95648 19.0671 6.347L15.5371 9.877C15.1466 10.2675 14.5134 10.2675 14.1229 9.877C13.7324 9.48647 13.7324 8.85331 14.1229 8.46279L17.6529 4.93279C18.0434 4.54226 18.6766 4.54226 19.0671 4.93279Z",
    fill: "#60666E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8771 14.123C10.2676 14.5135 10.2676 15.1467 9.8771 15.5372L5.6371 19.7772C5.24658 20.1677 4.61341 20.1677 4.22289 19.7772C3.83236 19.3867 3.83236 18.7535 4.22289 18.363L8.46289 14.123C8.85341 13.7324 9.48658 13.7324 9.8771 14.123Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLifeBuoy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/life-buoy.2dbeb0eb79ed0ebf8c633034405a26fb.svg";